module.exports = __webpack_public_path__ + "img/zyjy_11.16f2a0bb.png";